export default __webpack_public_path__ + "db2e60fe130e2b5633bb7271891084e8.png";